function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.3 7.7l-3.9 6.2m3.9-6.2l3.9 6.2m-1.6-2.4l-2.3 1.7L8 11.6m2.3 4.8V8m2.6-3.1c-.7-.7-1.7-1.1-2.8-1.1s-2 .4-2.7 1.2m.9.8c.5-.5 1.2-.7 1.9-.7s1.4.3 1.9.8m-2.9.8c.3-.2.6-.4 1-.4s.7.2 1 .4",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: ".5",
  stroke: "currentColor"
}));